(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerSection = this.header.querySelector('.header-section')
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-header"]) return;
  try {
    
  class MobileStickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-mobile-header');
      this.headerSection = this.header.querySelector('.mobile-header')
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-mobile-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-mobile-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky', 'animate');
    }
  }

  customElements.define('mobile-sticky-header', MobileStickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const carouselContainer = document.getElementById('shoppable-video-carousel-{{ section.id }}');
  if (!carouselContainer) return;

  const swiper = new Swiper('#shoppable-video-carousel-{{ section.id }} .swiper', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: window.innerWidth > 768,
    freeMode: {
      enabled: window.innerWidth <= 768,
      sticky: false,
      momentumRatio: 0.25,
      momentumVelocityRatio: 0.25,
    },
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 600,
    breakpoints: {
      320: {
        spaceBetween: 12,
        centeredSlides: false,
        freeMode: {
          enabled: true,
          sticky: true,
        },
      },
      768: {
        spaceBetween: 15,
        centeredSlides: false,
        freeMode: {
          enabled: true,
          sticky: false,
        },
      },
      769: {
        spaceBetween: 20,
        centeredSlides: true,
        freeMode: {
          enabled: false,
        },
        slidesPerView: 'auto',
      },
    },
    on: {
      init: function() {
        const firstSlideVideo = this.slides[this.activeIndex]?.querySelector('video');
        if (firstSlideVideo) {
          firstSlideVideo.closest('.video-container').classList.remove('is-paused');
          firstSlideVideo.play().catch(error => console.log("Autoplay prevented"));
        }
      },
      slideChange: function() {
        carouselContainer.querySelectorAll('video').forEach(video => {
          video.pause();
          video.closest('.video-container').classList.add('is-paused');
        });
        const activeVideo = this.slides[this.activeIndex]?.querySelector('video');
        if (activeVideo) {
          activeVideo.currentTime = 0;
          activeVideo.play().catch(error => console.log("Slide change autoplay prevented"));
          activeVideo.closest('.video-container').classList.remove('is-paused');
        }
      },
      touchStart: function() {
        carouselContainer.querySelectorAll('.slide-wrapper').forEach(slide => {
          slide.style.transition = 'transform 0.1s ease';
        });
      },
      touchEnd: function() {
        carouselContainer.querySelectorAll('.slide-wrapper').forEach(slide => {
          slide.style.transition = 'transform 0.3s ease, box-shadow 0.3s ease';
        });
      },
    },
  });

  carouselContainer.querySelectorAll('.video-overlay').forEach(overlay => {
    overlay.addEventListener('click', (e) => {
      e.stopPropagation();
      const videoContainer = e.currentTarget.closest('.video-container');
      const video = videoContainer.querySelector('video');
      if (video) {
        if (video.paused) {
          video.play();
          videoContainer.classList.remove('is-paused');
        } else {
          video.pause();
          videoContainer.classList.add('is-paused');
        }
      }
    });
  });

  const forms = carouselContainer.querySelectorAll('.product-form');
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const button = this.querySelector('.buy-button');
      const buttonText = button.querySelector('.button-text');
      const buttonLoading = button.querySelector('.button-loading');

      if (button.disabled) return;

      buttonText.style.display = 'none';
      buttonLoading.style.display = 'inline-block';
      button.disabled = true;

      const formData = new FormData(this);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        buttonText.textContent = 'Added!';
        button.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:updated', { 
          bubbles: true, 
          detail: data 
        }));
        
        setTimeout(() => {
          buttonText.textContent = 'Buy Now';
          button.classList.remove('is-added');
          button.disabled = false;
        }, 2000);
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        buttonText.textContent = 'Try Again';
        button.style.backgroundColor = '#F56565';
        
        setTimeout(() => {
          buttonText.textContent = 'Buy Now';
          button.style.backgroundColor = '';
          button.disabled = false;
        }, 2500);
      })
      .finally(() => {
        buttonLoading.style.display = 'none';
        buttonText.style.display = 'inline-block';
      });
    });
  });

  carouselContainer.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      swiper.slidePrev();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      swiper.slideNext();
    }
  });

  if (window.innerWidth > 768) {
    carouselContainer.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      e.preventDefault();
      if (e.deltaY > 0) {
        swiper.slideNext();
      } else {
        swiper.slidePrev();
      }
    }, { passive: false });
  }
});

  } catch(e) { console.error(e); }
})();
})();
